@if (showHeader) {
<app-header ngSkipHydration></app-header>
}
<div class="app" [ngClass]="{ 'page-content': showPageContent }">
  @if (!isMobile() && showLeftSidebar) {
<div class="app__right-sidebar">
    <app-left-sidebar></app-left-sidebar>
  </div>
}
  <div class="app__content">
    <router-outlet class="app__router-outlet"></router-outlet>
  </div>
</div>
